<template>
  <hr class="horizontal" style="margin: 8px 0" />

  <div class="d-flex-column justify-start align-start gap-18">
    <!-- <div class="d-flex-column justify-start align-start gap-5">
      <h5 class="medium-l t-white font-family-2">
        {{ $t("missed.mode") }}
      </h5>
    </div> -->

    <div
      class="d-flex-row server_picker_singler b-radius-9 space-between"
      :class="[direction]"
    >
      <div
        class="server_btn b-radius-9 d-flex-row"
        :key="extraOption.id"
        v-for="extraOption in getGamePack.pack_extra_options"
        role="button"
        @click.stop="() => selectOption(extraOption)"
        :class="[
          checkoutStore.getPackExtraOptions?.mode === extraOption.id &&
            'active',
        ]"
      >
        <label class="t-white regular-l font-family-2 f-w-500">{{
          extraOption?.title
        }}</label>
      </div>
    </div>
  </div>
  <hr class="horizontal" style="margin: 8px 0" />
</template>

<script setup>
const { getGamePack } = useGameStore();
const checkoutStore = useCheckoutStore();
const { categoryPackSlug } = useGameComposable();
const isSelected = (option) => {
  if (checkoutStore.getPackExtraOptions?.mode) {
    return checkoutStore.getPackExtraOptions?.mode === option.id;
  }
  return false;
};

const selectOption = (option) => {
  checkoutStore.setPackExtraOptions({ mode: option.id });
};
const switchClick = (option) => {
  // this.selectOption(option);
};

const direction = computed(() => {
  if (!checkoutStore.getPackExtraOptions?.mode) return "";
  if (
    categoryPackSlug === "wow-2v2-arena-boost" ||
    categoryPackSlug === "wow-3v3-arena-boost"
  ) {
    const selectedOption = getGamePack.pack_extra_options?.find(
      (op) => op.id === checkoutStore.getPackExtraOptions?.mode
    );
    if (selectedOption?.description === "The War Within") {
      return "right";
    }
    if (selectedOption?.description === "classic") {
      return "left";
    }
    // return selectedOption.value.const_title === "account_sharing"
    //   ? "left"
    //   : "right";
  }
  return "";
});
</script>

<style lang="scss">
.server_picker_singler {
  background-color: var(--bg-medium);
  padding: 6px 6px;
  position: relative;
  .server_btn {
    min-height: 35px;
    cursor: pointer;
    z-index: 2;
    & > * {
      cursor: pointer;
    }
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 45%;
    left: 0%;
    transform: translate(6px, -50%);
    min-height: 35px;
    background-color: var(--blue-opace);
    border: 1px solid var(--blue);
    border-radius: 9px;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }
  &.left {
    &::after {
      opacity: 1;
    }
  }
  &.right {
    &::after {
      opacity: 1;
      left: 100%;
      transform: translate(calc(-100% - 6px), -50%);
    }
  }
}
</style>
